"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.navigate = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("../Button"));
var _StandaloneDatePicker = _interopRequireDefault(require("../StandaloneDatePicker"));
var _Divider = _interopRequireDefault(require("../Divider"));
var _Dropdown = _interopRequireDefault(require("../Dropdown"));
var _DropdownItem = _interopRequireDefault(require("../Dropdown/DropdownItem"));
var _FormControl = _interopRequireDefault(require("../FormControl"));
var _Grid = _interopRequireDefault(require("../Grid"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _Popper = _interopRequireDefault(require("../Popper"));
var _Calendar = require("./Calendar");
var _EDSContext = require("../EDSContext/EDSContext");
var _styles = _interopRequireDefault(require("../styles"));
var _tokens = require("../styles/tokens");
var _Calendar2 = _interopRequireDefault(require("@ellucian/ds-icons/lib/Calendar"));
var _ChevronLeft = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronLeft"));
var _ChevronRight = _interopRequireDefault(require("@ellucian/ds-icons/lib/ChevronRight"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Default imports

// Internal components and functions

// DS Icons imports

// Utilities

// create constants for navigation used in react-big-calendar
var navigate = {
  PREVIOUS: 'PREV',
  NEXT: 'NEXT',
  TODAY: 'TODAY',
  DATE: 'DATE'
};
exports.navigate = navigate;
var styles = function styles() {
  return {
    alignLabel: {
      alignSelf: 'center'
    },
    iconRoot: {
      height: _tokens.sizingSmall,
      width: _tokens.sizingSmall
    },
    iconButtonMargin: {
      margin: "0 " + _tokens.spacing20
    },
    toolbar: {
      minWidth: '6.25rem'
    },
    gridMarginOverride: {
      margin: 0,
      width: _tokens.widthFluid
    },
    popperIndex: {
      zIndex: 5
    },
    todayButton: {
      flex: 1
    },
    datePickerPopper: {
      padding: 0
    }
  };
};
var CalendarToolbar = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
    localizer = props.localizer,
    label = props.label,
    edsContext = props.edsContext,
    onNavigate = props.onNavigate,
    onView = props.onView,
    views = props.views;

  // Initialize states using useState hook
  var _useState = (0, _react.useState)(null),
    anchorEl = _useState[0],
    setAnchorEl = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    open = _useState2[0],
    setOpen = _useState2[1];
  var messages = localizer.messages;
  var _useContext = (0, _react.useContext)(_Calendar.CalendarContext),
    date = _useContext.date,
    ToolbarDropdownProps = _useContext.ToolbarDropdownProps,
    setDate = _useContext.setDate,
    showViewNames = _useContext.showViewNames,
    selectedView = _useContext.selectedView,
    setSelectedView = _useContext.setSelectedView,
    width = _useContext.width;
  var handleClick = function handleClick(event) {
    var currentTarget = event.currentTarget;
    setAnchorEl(currentTarget);
    setOpen(true);
  };
  var handleClickAway = function handleClickAway() {
    setOpen(false);
  };
  var handleDateChange = function handleDateChange(selectedDate) {
    setOpen(false);
    setDate(selectedDate);
  };
  var handleNavigation = function handleNavigation(action) {
    onNavigate(action);
  };
  var handleViewChange = function handleViewChange(event) {
    var value = event.target.value;
    onView(value);
    setSelectedView(value);
  };
  var sentenceCase = function sentenceCase(message) {
    return message.toLowerCase().split(' ').map(function (word, index) {
      return word.replace(word[0], index > 0 ? word[0].toLowerCase() : word[0].toUpperCase());
    }).join(' ');
  };
  var dropdownControl = views.length >= 1 && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    className: "rbc-btn-group",
    item: true
  }, /*#__PURE__*/_react.default.createElement(_FormControl.default, {
    className: classes.toolbar
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.default, (0, _extends2.default)({
    label: "",
    onChange: handleViewChange,
    value: selectedView,
    size: "small"
  }, ToolbarDropdownProps), views.map(function (name) {
    return /*#__PURE__*/_react.default.createElement(_DropdownItem.default, {
      key: name,
      label: sentenceCase(messages[name]),
      value: name
    });
  }))));
  var datePickerControl = /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    classes: {
      'spacing-xs-2': classes.gridMarginOverride,
      'spacing-xs-3': classes.gridMarginOverride
    },
    container: true,
    direction: "row",
    justifyContent: "flex-end",
    spacing: 0
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: edsContext.formatMessage('component.CalendarToolBar.openDatePicker'),
    enterDelay: 1000,
    enterNextDelay: 1000
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    "aria-label": edsContext.formatMessage('component.CalendarToolBar.openDatePicker'),
    color: "gray",
    onClick: handleClick,
    "aria-haspopup": "true"
  }, /*#__PURE__*/_react.default.createElement(_Calendar2.default, null))), /*#__PURE__*/_react.default.createElement(_Popper.default, {
    anchorEl: anchorEl,
    className: classes.popperIndex,
    onClickAway: handleClickAway,
    disablePortal: true,
    open: open,
    PaperProps: {
      classes: {
        root: classes.datePickerPopper
      }
    },
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 8]
      }
    }],
    placement: "bottom-end"
  }, /*#__PURE__*/_react.default.createElement(_StandaloneDatePicker.default, {
    id: "CalendarToolbar__StandaloneDatePicker",
    value: date || new Date(),
    onChange: handleDateChange
  })))));
  var labelNavigation = /*#__PURE__*/_react.default.createElement(_Grid.default, {
    dir: edsContext.dir,
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    classes: {
      'spacing-xs-2': classes.gridMarginOverride,
      'spacing-xs-3': classes.gridMarginOverride
    },
    container: true,
    direction: "row",
    justifyContent: "flex-start",
    spacing: 0,
    wrap: "nowrap"
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: edsContext.formatMessage('component.Calendar.previous'),
    enterDelay: 1000,
    enterNextDelay: 1000
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    color: "gray",
    className: classes.iconButtonMargin,
    onClick: function onClick() {
      return handleNavigation(navigate.PREVIOUS);
    },
    "aria-label": edsContext.formatMessage('component.Calendar.previous')
  }, edsContext.dir === 'rtl' ? /*#__PURE__*/_react.default.createElement(_ChevronRight.default, {
    className: classes.iconRoot
  }) : /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, {
    className: classes.iconRoot
  })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    className: classes.alignLabel,
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body1",
    component: "div",
    className: "hedtech-calendar-date-title"
  }, label)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: edsContext.formatMessage('component.Calendar.next'),
    enterDelay: 1000,
    enterNextDelay: 1000
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    color: "gray",
    className: classes.iconButtonMargin,
    onClick: function onClick() {
      return handleNavigation(navigate.NEXT);
    },
    "aria-label": edsContext.formatMessage('component.Calendar.next')
  }, edsContext.dir === 'rtl' ? /*#__PURE__*/_react.default.createElement(_ChevronLeft.default, {
    className: classes.iconRoot
  }) : /*#__PURE__*/_react.default.createElement(_ChevronRight.default, {
    className: classes.iconRoot
  }))))));
  var todayButton = /*#__PURE__*/_react.default.createElement(_Grid.default, {
    className: (0, _classnames.default)(classes.alignLabel, classes.todayButton),
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: function onClick() {
      return handleNavigation(navigate.TODAY);
    },
    variant: "text"
  }, messages.today));
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    classes: {
      'spacing-xs-2': classes.gridMarginOverride,
      'spacing-xs-3': classes.gridMarginOverride
    },
    className: "calendar-toolbar",
    container: true,
    direction: "column",
    spacing: 0,
    wrap: "nowrap",
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    dir: edsContext.dir,
    classes: {
      'spacing-xs-2': classes.gridMarginOverride,
      'spacing-xs-3': classes.gridMarginOverride
    },
    container: true,
    direction: "row",
    justifyContent: showViewNames ? 'space-between' : 'flex-end',
    spacing: 2
  }, todayButton, showViewNames && width !== 'xs' && dropdownControl, datePickerControl)), width === 'xs' && /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    classes: {
      'spacing-xs-2': classes.gridMarginOverride,
      'spacing-xs-3': classes.gridMarginOverride
    },
    container: true,
    justifyContent: "center",
    spacing: 2
  }, showViewNames && width === 'xs' && dropdownControl)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Divider.default, {
    className: classes.divider,
    style: {
      margin: '0 1rem'
    },
    variant: "middle"
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    classes: {
      'spacing-xs-2': classes.gridMarginOverride,
      'spacing-xs-3': classes.gridMarginOverride
    },
    container: true,
    justifyContent: "center",
    spacing: 2
  }, labelNavigation)));
});
CalendarToolbar.propTypes = {
  /**
   * JSS classes object.
   */
  classes: _propTypes.default.object,
  /**
   * The active view to display.
   */
  view: _propTypes.default.string.isRequired,
  /**
   * An array of views that is sent by react-big-calendar.
   */
  views: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  /**
   * @ignore
   */
  edsContext: _propTypes.default.object,
  /**
   * The node to render the date range label.
   */
  label: _propTypes.default.node.isRequired,
  /**
   * Internal localizer function used by react-big-calendar.
   */
  localizer: _propTypes.default.object,
  /**
   * @ignore
   */
  onNavigate: _propTypes.default.func.isRequired,
  /**
   * @ignore
   */
  onView: _propTypes.default.func.isRequired
};
CalendarToolbar.displayName = 'CalendarToolbar';
var _default = (0, _EDSContext.withEDSContext)((0, _styles.default)(styles)(CalendarToolbar));
exports.default = _default;